class CollectionsSearch extends HTMLElement {
  #debounceTimer = null;
  #cardsData = [];

  constructor() {
    super();
    this.input = this.querySelector("[data-search-input]");
    this.grid = document.querySelector("[data-collections-grid]");
    this.noResults = document.querySelector("[data-no-results]");
  }

  connectedCallback() {
    if (!this.input || !this.grid) return;

    const cards = this.grid.querySelectorAll("[data-collection-card]");

    this.#cardsData = Array.from(cards, (card) => ({
      element: card,
      title: card.dataset.collectionTitle || "",
      location: card.dataset.collectionLocation || "",
    }));

    this.input.addEventListener("input", () => this.#handleInput());
  }

  #handleInput() {
    clearTimeout(this.#debounceTimer);
    this.#debounceTimer = setTimeout(() => this.#filterCollections(), 150);
  }

  #filterCollections() {
    const query = this.input.value.toLowerCase().trim();
    let visibleCount = 0;

    requestAnimationFrame(() => {
      for (const { element, title, location } of this.#cardsData) {
        const isMatch = query === "" || title.includes(query) || location.includes(query);
        element.classList.toggle("is-hidden", !isMatch);
        if (isMatch) visibleCount++;
      }

      if (this.noResults) {
        const hasNoResults = query !== "" && visibleCount === 0;
        this.noResults.classList.toggle("is-hidden", !hasNoResults);
        this.noResults.textContent = this.noResults.dataset.template.replace("%s", query);
      }
    });
  }
}

customElements.define("collections-search", CollectionsSearch);
